// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoContent_sakhalin_wrapper__2h9dD","title":"VideoContent_sakhalin_title__gLq4C","bottomBlock":"VideoContent_sakhalin_bottomBlock__1Zogx"};